import { Stack, Typography } from '@mui/material'
import React from 'react'

type Props = {
  color?: string
  left: string | React.ReactElement
  right: string | React.ReactElement
}

const SubtotalLine: React.FC<Props> = ({ color, left, right }) => {
  const colorToUse = color || 'text.secondary'
  return (
    <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
      {typeof left === 'string' ? (
        <Typography color={colorToUse} variant="body1">
          {left}
        </Typography>
      ) : (
        left
      )}
      {typeof right === 'string' ? (
        <Typography color={colorToUse} variant="body1">
          {right}
        </Typography>
      ) : (
        right
      )}
    </Stack>
  )
}

export default SubtotalLine
